"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogContent: function() {
        return _DialogContent.DialogContent;
    },
    dialogContentClassNames: function() {
        return _useDialogContentStylesstyles.dialogContentClassNames;
    },
    renderDialogContent_unstable: function() {
        return _renderDialogContent.renderDialogContent_unstable;
    },
    useDialogContentStyles_unstable: function() {
        return _useDialogContentStylesstyles.useDialogContentStyles_unstable;
    },
    useDialogContent_unstable: function() {
        return _useDialogContent.useDialogContent_unstable;
    }
});
const _DialogContent = require("./DialogContent");
const _renderDialogContent = require("./renderDialogContent");
const _useDialogContent = require("./useDialogContent");
const _useDialogContentStylesstyles = require("./useDialogContentStyles.styles");
